<form class="drop-padding" [formGroup]="form">
  <mat-form-field appearance="outline">
    <mat-label>Кол-во</mat-label>
    <input matInput formControlName="quan" type="number" />
  </mat-form-field>
  <button mat-flat-button color="primary" (click)="print()">Печать</button>
</form>
